import { render, staticRenderFns } from "./First.vue?vue&type=template&id=120f3a1a&"
import script from "./First.vue?vue&type=script&lang=ts&"
export * from "./First.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports